var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 47,
    viewBox: "0 0 61 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1269 1.07324C40.2305 1.06995 50.017 4.59785 57.795 11.0471C60.1837 12.9935 60.6437 15.1403 59.1161 16.9864C57.5885 18.8323 55.577 18.7028 53.218 16.8506C38.9395 5.41998 22.0111 5.44947 7.70836 16.939C5.50239 18.7086 3.27904 18.7086 1.84571 16.874C0.412799 15.04 0.802365 13.1643 3.00214 11.3183C10.5964 4.88544 20.176 1.26699 30.1268 1.0733L30.1269 1.07324Z",
    fill: "#FFF744",
    stroke: "#33343C",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2987 13.0765C38.1887 13.2563 44.7926 15.8679 49.9428 20.449C52.1192 22.3658 52.4673 24.5365 50.9335 26.2586C49.4829 27.91 47.3299 27.8216 45.2597 26.0936C35.9527 18.373 25.4065 18.3673 15.9696 26.0936C13.7048 27.91 11.5757 27.91 10.0893 26.0994C8.69167 24.3715 9.04553 22.3896 11.1215 20.4963C16.2178 15.8544 23.6191 13.0411 31.2991 13.0765L31.2987 13.0765Z",
    fill: "#FFF744",
    stroke: "#33343C",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5669 24.9945C34.8983 25.1324 39.0478 26.766 42.3103 29.6188C44.1683 31.2703 44.3982 33.4523 42.9887 35.0627C41.6677 36.5726 39.5325 36.6844 37.6807 35.3457C32.0954 31.353 29.0814 31.3468 23.4601 35.3161C21.5257 36.6845 19.4851 36.5783 18.1521 35.0508C16.7365 33.4051 17.0018 31.2287 18.8186 29.5835C21.7022 26.9529 26.7803 24.9592 30.5673 24.9946L30.5669 24.9945Z",
    fill: "#FFF744",
    stroke: "#33343C",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4622 37.7657C31.6343 37.7607 32.7612 38.217 33.6001 39.0357C34.4385 39.8545 34.9215 40.9702 34.945 42.1419C34.8994 43.2687 34.4357 44.3381 33.6438 45.1407C32.8518 45.9434 31.7892 46.4223 30.663 46.4828C29.4913 46.4893 28.3665 46.0253 27.5405 45.1947C26.7144 44.3641 26.2565 43.2367 26.2688 42.0654C26.2581 40.9398 26.693 39.8558 27.4787 39.0502C28.2645 38.2446 29.3371 37.7826 30.4623 37.7658L30.4622 37.7657Z",
    fill: "#FFF744",
    stroke: "#33343C",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiYellow);
export default __webpack_public_path__ + "static/media/Wifi_Yellow.57e86b598da934d10269202c3b97f637.svg";
export { ForwardRef as ReactComponent };